import { EntityName } from '@adm/backend-entity';

import { Models, OwnershipAction, UserRole } from '../../enums';

export const ownershipPermissions: Record<
  UserRole,
  { actions: Array<keyof typeof OwnershipAction>; subject: Models; fields?: Array<EntityName> }[]
> = {
  [UserRole.Admin]: [
    {
      actions: [
        OwnershipAction.read,
        OwnershipAction.create,
        OwnershipAction.update,
        OwnershipAction.finish,
        OwnershipAction.addDriver,
        OwnershipAction.deleteDriver,
        OwnershipAction.updatePartner,
        OwnershipAction.sendBatchPushes,
      ],
      subject: Models.Ownership,
    },
    { actions: [OwnershipAction.read], subject: Models.Ownerships },
    { actions: [OwnershipAction.getTelematics], subject: Models.StatisticsInfo },
    { actions: [OwnershipAction.getTelematics], subject: Models.TripsDailyInfo },
  ],

  [UserRole.Operator]: [
    {
      actions: [
        OwnershipAction.read,
        OwnershipAction.create,
        OwnershipAction.update,
        OwnershipAction.finish,
        OwnershipAction.addDriver,
        OwnershipAction.deleteDriver,
        OwnershipAction.sendBatchPushes,
      ],
      subject: Models.Ownership,
    },
    { actions: [OwnershipAction.read], subject: Models.Ownerships },
    { actions: [OwnershipAction.getTelematics], subject: Models.StatisticsInfo },
    { actions: [OwnershipAction.getTelematics], subject: Models.TripsDailyInfo },
  ],

  [UserRole.OperatorWithoutPBAccess]: [
    {
      actions: [
        OwnershipAction.read,
        OwnershipAction.create,
        OwnershipAction.update,
        OwnershipAction.finish,
        OwnershipAction.addDriver,
        OwnershipAction.deleteDriver,
      ],
      subject: Models.Ownership,
    },
    { actions: [OwnershipAction.read], subject: Models.Ownerships },
    { actions: [OwnershipAction.getTelematics], subject: Models.StatisticsInfo },
    { actions: [OwnershipAction.getTelematics], subject: Models.TripsDailyInfo },
  ],

  [UserRole.DeviceOperator]: [],

  [UserRole.OperatorReadAccess]: [
    { actions: [OwnershipAction.read], subject: Models.Ownership },
    { actions: [OwnershipAction.read], subject: Models.Ownerships },
    { actions: [OwnershipAction.getTelematics], subject: Models.StatisticsInfo },
    { actions: [OwnershipAction.getTelematics], subject: Models.TripsDailyInfo },
  ],

  [UserRole.TtmOperator]: [],

  [UserRole.DeviceQualityOperator]: [],
};
